import { useAuth } from '../../contexts/auth';
import { useDisplay } from '../../contexts/display';
import HeaderDefault from './header';
import HeaderMobile from './m-header';

function Header() {
  const { isMobile } = useDisplay();
  const { user } = useAuth();
  
  if (user != null)
    return isMobile ? <HeaderMobile /> : <HeaderDefault />
  else
    return <></>;
}

export default Header;
